export default {
	"settlement.accounting-date": "Accounting Date",
	"settlement.event-type": "Event Type",
	"settlement.start-time": "Start Time",
	"settlement.end-time": "End Time",
	"settlement.shift-number": "Shift No.",
	"settlement.reference": "Ref.",
	"settlement.remarks": "Remarks",
	"settlement.is-cancelled": "Cancelled",
	"settlement.settled-by": "Settled By",

	// settlement details columns
	"settlement.float": "Float",
	"settlement.revenue": "Revenue",
	"settlement.collected": "Collected",
	"settlement.difference": "Difference",
	"settlement.transaction-count": "Tx. Count",
	"settlement.payment-type": "Payment Type",

	// event types
	"settlement.event.open": "OPEN",
	"settlement.event.change-shift": "CHANGE SHIFT",
	"settlement.event.close": "CLOSE",
	"settlement.event.cancelled": "CANCELLED",

	"settlement.edit-collection": "Edit Cash Collection Amount",
	"settlement.edit-successful": "Edit Cash Collection Successful"
}